import React, { useState } from 'react';
import { Modal, Box, Typography, Button, Grid, Paper, Divider, TextField } from '@mui/material';
import apiClient from 'Utils/apiClient';
import socketService from 'socket/newsocketService';
import { getDatabase, ref, update } from 'firebase/database';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxWidth: 800,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const MonitoringModal = ({ open, onClose, escort }) => {
  const [resolutionNote, setResolutionNote] = useState('');

  const handleManualCheck = async () => {
    try {
      const nowMs = Date.now();
      const tripId = escort?.tripId || escort?.escortDocumentId || escort?.id || escort?.escortId;
      // 1. Emit via socket
      socketService.emit("manual_wellbeing_check", {
        escortId: escort?.escortId,
        userId: escort?.userId,
        state: escort?.userState || escort?.state,
        adminName: 'Admin',
        tripId,
      });
      socketService.emit("sendcustompushnotification", {
        userId: escort?.userId,
        title: "Wellbeing Check",
        message: "Please Confirm Your Safety",
        action: "wellbeingcheck",
        tripId,
      });

      if (escort?.userId) {
        try {
          const db = getDatabase();
          update(ref(db, `users/${escort.userId}`), {
            Wellbeing_Response: "Awaiting Response",
            wellbeingResponse: "Awaiting Response",
            wellbeingCheckSource: "Sent by Escort Staff",
            wellbeingSentAt: nowMs,
            wellbeingPushStatus: "Delivered",
            userFBK: null,
            userFeedback: null,
            feedback: null,
          });
          localStorage.setItem(`wb_sent_${escort.userId}`, String(nowMs));
          localStorage.setItem(`wb_awaiting_${escort.userId}`, String(nowMs));
          localStorage.removeItem(`wb_resp_dur_${escort.userId}`);
        } catch (fbErr) {
          console.warn("Direct Firebase update notice:", fbErr?.message);
        }
      }
      if (tripId) {
        localStorage.setItem(`wb_sent_${tripId}`, String(nowMs));
        localStorage.setItem(`wb_awaiting_${tripId}`, String(nowMs));
        localStorage.removeItem(`wb_resp_dur_${tripId}`);
      }

      // 2. Fallback HTTP call wrapped in catch
      apiClient.post(`/virtual-escort/admin/manual-check/${escort.escortId}`, {
        userId: escort?.userId,
      }).catch((err) => {
        console.warn("HTTP manual-check fallback notice:", err?.message);
      });

      alert('Manual check sent and response timer started');
    } catch (e) {
      console.error("Failed to send check:", e);
      alert('Failed to send check');
    }
  };

  const handleResolve = async () => {
    try {
      await apiClient.put(`/virtual-escort/admin/resolve/${escort.escortId}`, { resolutionNote });
      alert('Escort resolved');
      onClose();
    } catch (e) {
      alert('Failed to resolve');
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h5" component="h2" mb={2}>
          Escort Monitoring - {escort.user?.name}
        </Typography>
        
        <Grid container spacing={2}>
          <Grid item xs={6} md={3}>
            <Paper sx={{ p: 2, textAlign: 'center', bgcolor: '#f5f5f5' }}>
              <Typography variant="caption">Movement</Typography>
              <Typography variant="h6">{escort.isMoving ? 'Moving' : 'Stopped'}</Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} md={3}>
            <Paper sx={{ p: 2, textAlign: 'center', bgcolor: '#f5f5f5' }}>
              <Typography variant="caption">Battery</Typography>
              <Typography variant="h6" color={escort.batteryLevel <= 15 ? 'error' : 'inherit'}>{escort.batteryLevel}%</Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} md={3}>
            <Paper sx={{ p: 2, textAlign: 'center', bgcolor: '#f5f5f5' }}>
              <Typography variant="caption">Phone Status</Typography>
              <Typography variant="h6">{escort.activity === 'Phone Switched Off' ? 'Offline' : 'Online'}</Typography>
            </Paper>
          </Grid>
          <Grid item xs={6} md={3}>
            <Paper sx={{ p: 2, textAlign: 'center', bgcolor: '#f5f5f5' }}>
              <Typography variant="caption">Priority</Typography>
              <Typography variant="h6" color={escort.priority === 'Critical' ? 'error' : 'inherit'}>{escort.priority}</Typography>
            </Paper>
          </Grid>
        </Grid>

        <Box mt={3} mb={3}>
          <Typography variant="h6">Wellbeing Status: {escort.wellbeingResponse}</Typography>
          {escort.wellbeingCheckSource && (
            <Typography variant="body2" color="textSecondary">Source: {escort.wellbeingCheckSource} | Status: {escort.wellbeingPushStatus}</Typography>
          )}
        </Box>

        <Divider />
        <Box mt={2} mb={2}>
           <Typography variant="h6">Admin Actions</Typography>
           <Box display="flex" gap={2} mt={1}>
              <Button variant="outlined" color="primary" onClick={handleManualCheck}>Send Manual Wellbeing Check</Button>
              <Button variant="outlined" color="info">Call User</Button>
              <Button variant="outlined" color="secondary">View Live Map</Button>
           </Box>
        </Box>

        <Divider />
        <Box mt={2}>
           <Typography variant="h6">Resolve Escort</Typography>
           <TextField 
             fullWidth 
             multiline 
             rows={2} 
             placeholder="Optional resolution note..." 
             value={resolutionNote}
             onChange={e => setResolutionNote(e.target.value)}
             sx={{ mt: 1, mb: 2 }}
           />
           <Button variant="contained" color="success" onClick={handleResolve}>Mark as Resolved</Button>
           <Button variant="text" onClick={onClose} sx={{ ml: 2 }}>Close</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default MonitoringModal;
